import { useState, useCallback } from 'react';

export type FieldErrors = Record<string, string>;

export const useFormErrors = () => {
  const [fieldErrors, setFieldErrorsState] = useState<FieldErrors>({});

  const clearFieldError = useCallback((field: string) => {
    setFieldErrorsState(prev => {
      if (prev[field]) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { [field]: _, ...rest } = prev;
        return rest;
      }
      return prev;
    });
  }, []);

  const clearAllErrors = useCallback(() => {
    setFieldErrorsState({});
  }, []);

  const setFieldErrors = useCallback((errors: FieldErrors) => {
    setFieldErrorsState(prev => ({
      ...prev,
      ...errors,
    }));
  }, []);

  return {
    fieldErrors,
    setFieldErrors,
    clearFieldError,
    clearAllErrors,
  };
};
